import React, { useCallback, useState } from 'react';
import { createContext, useContext } from 'react';

type GlobalMenuContextProps = {
  isShowMenu: boolean;
  setIsShowMenu: (isShowMenu: boolean) => () => void; // clean up functionも返している
};

const GlobalMenuContext = createContext<GlobalMenuContextProps>({
  isShowMenu: false,
  setIsShowMenu: _ => () => {
    return;
  },
});

export const useGlobalMenuContext = (): GlobalMenuContextProps => {
  const context = useContext(GlobalMenuContext);

  return context;
};

export const GlobalMenuProvider = (props: { children: React.ReactNode }) => {
  const [isShowMenu, setIsShowMenu_] = useState<boolean>(false);
  const setIsShowMenu = useCallback((isShowMenu: boolean) => {
    let prev: boolean | undefined;
    setIsShowMenu_(p => {
      prev = p;
      return isShowMenu;
    });
    return () => setIsShowMenu_(prev ?? false);
  }, []);
  return (
    <>
      <GlobalMenuContext.Provider
        value={{
          isShowMenu,
          setIsShowMenu,
        }}>
        {props.children}
      </GlobalMenuContext.Provider>
    </>
  );
};
